import { MotifProgressLoader } from "@ey-xd/motif-react";

type LoaderProps = {
  className?: string;
  show?: boolean;
  variant?: "linear" | "circular" | "default";
};

function Loader({
  className,
  show = true,
  variant = "default",
}: LoaderProps) {
  return (
    <>
      <MotifProgressLoader
        aria-busy="true"
        aria-label="This page is loading"
        aria-live="polite"
        arialabel="This page is loading"
        className={className}
        role="alertdialog"
        show={show}
        tabIndex={0}
        variant={variant}
      />
    </>
  );
}

export default Loader;
